import Content from "./Content";
import BaseWrapper from "../BaseWrapper/BaseWrapper"

const Dashboard = () => <BaseWrapper content={<Content />}/>

export default Dashboard